module.exports = __webpack_public_path__ + "img/glow-violet.3cf61fd9.png";